import TextField from '@material-ui/core/TextField';

/** @deprecated */
export default TextField;
